<div class="app-header" *ngIf="isMobileApp === false">
  <div
    class="link-bar d-flex flex-wrap align-items-center justify-content-between"
  >
    <div class="col app-header-text">
      <h3>
        <span>Pediatric Gym Waiver</span>
      </h3>
      <!-- <h5><span>No personal information is collected or stored.</span></h5> -->
    </div>
  </div>
</div>
<div class="col order-2 order-md-1 d-flex justify-content-end">
  <button
    *ngIf="nextAvailable"
    class="app-header-link btn btn-link btn-link-dark"
    (click)="next.emit()"
  >
    Next &gt;
  </button>
</div>
